$(function(){
setTimeout(() => {
  // ページロード時に利用規約チェックをデフォルトにする
  $("#formCheckboxAgree").prop('checked', false);
}, 0);
// 利用規約同意にチェックで確認ボタンのスタイルを変更 
$("#formCheckboxAgree").on("load, change", function(){
  if( $("#formCheckboxAgree").is(":checked") ){
    $("#formButtonSubmit").addClass("-checked");
  }else{
    $("#formButtonSubmit").removeClass("-checked");
  }
})
// 利用規約同意にチェックの場合submit
$("body[data-controller='index'] #formButtonSubmit").on("click", function(e){
  e.preventDefault();
  e.stopPropagation();
  
  if( $("#formCheckboxAgree").is(":checked") ){
    $("form.form").submit();
  }
});
// sfへ送信するformをsubmit
$("body[data-controller='confirm'] #formButtonSubmit").on("click", function(e){
  e.preventDefault();
  e.stopPropagation(); 
  $("form.sfForm").submit();
});
// checkboxの選択可能数を制限
$(".js-checkbox-limit input").on("change", function(e){
  // 選択可能上限を取得
  let limit = $(this).closest(".checkboxGroupWrap").data("limit");
  // 直下のinputのみを含み、-inner内のinputを除外
  let length = $(this).closest(".checkboxGroupWrap").find("> label > input:checkbox:checked").length;
  // 上限を超えた場合、それ以上のcheckを無効にする
  if(length > limit){
    $(this).prop('checked', false);
  }
});
// 戻るボタン遷移
$("#formButtonBack").on("click",function(){
  $("#form").submit();
});
});